import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const ListNFTForSale = () => {
  const toastRef = useRef();
  const [nfts, setNfts] = useState([]);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [price, setPrice] = useState("0");
  const [openToOffers, setOpenToOffers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userAddress, setUserAddress] = useState();
  useEffect(() => {
    const storedAddress = localStorage.getItem("walletAddress");
    if (storedAddress) {
      setUserAddress(storedAddress);
      fetchUserNFTs(storedAddress);
    }
  }, []);

  const fetchUserNFTs = async (userAddress) => {
    try {
      const response = await fetch(
        `${domainpath}/api/art/?userId=${userAddress}`
      );
      const data = await response.json();
      console.log(data, "data");
      if (data.success === true) {
        setNfts(data?.data);
      }
    } catch (error) {
      console.error("Error fetching NFTs:", error);
    }
  };

  const handleListNFT = async () => {
    if (!selectedNFT) return alert("Please select an NFT.");
    if (!price && !openToOffers)
      return alert("Set a price or enable Open to Offers.");

    setLoading(true);
    try {
      const response = await axios.post("/api/art/list-nft", {
        userAddress,
        nft_id: selectedNFT.nft_id,
        price: openToOffers ? null : price, // If open to offers, price is optional
        open_to_offers: openToOffers,
      });
      if (response.status === 201) {
        toastRef.current.addToast("NFT listed successfully!", "success");

        fetchUserNFTs();
      }
      // Refresh list
    } catch (error) {
      console.error("Error listing NFT:", error);
      alert("Failed to list NFT.");
    }
    setLoading(false);
  };

  return (
    <section className="container">
      <div className="p-6 bg-white rounded-lg shadow-lg">
        <h2 className="text-xl font-bold mb-4">List NFT for Sale</h2>

        {nfts.length === 0 ? (
          <p>No NFTs available to list.</p>
        ) : (
          <>
            <label className="block text-sm font-medium text-gray-700">
              Select NFT:
            </label>
            <select
              className="w-full p-2 border rounded mb-4"
              onChange={(e) =>
                setSelectedNFT(nfts.find((n) => n.nft_id === e.target.value))
              }
            >
              <option value="">-- Choose NFT --</option>
              {nfts.map((nft) => (
                <option key={nft.nft_id} value={nft.nft_id}>
                  {nft.title} - {nft.nft_id}
                </option>
              ))}
            </select>

            {/* Price input - Optional if Open to Offers is enabled */}
            {!openToOffers && (
              <>
                <label className="block text-sm font-medium text-gray-700">
                  Set Price (Tez):
                </label>
                <input
                  type="number"
                  className="w-full p-2 border rounded mb-4"
                  value={price}
                  min={0}
                  onChange={(e) => setPrice(e.target.value)}
                  placeholder="Enter price in Tez"
                />
              </>
            )}

            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                checked={openToOffers}
                onChange={() => {
                  setOpenToOffers(!openToOffers);
                  if (!openToOffers) setPrice(""); // Reset price if Open to Offers is enabled
                }}
                className="mr-2"
              />
              <span>Open to Offers (Buyers can propose a price)</span>
            </div>

            <button
              className="w-full bg-blue-600 text-white p-2 rounded disabled:bg-gray-400"
              onClick={handleListNFT}
              disabled={loading}
            >
              {loading ? "Listing..." : "List NFT"}
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default ListNFTForSale;
